import { EventEmitter, Injectable, Output } from '@angular/core';
import { QueryObjectsModel } from '@barthauer/abc/core/data';
import { ResourceManager } from '@barthauer/abc/core/resources';
import { MeasureTask, Project, SubProject } from '@barthauer/custom/xmt-models';
import { BehaviorSubject, Observable, ReplaySubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  @Output() selectItem = new EventEmitter();
  private measureNameSubject: Subject<string> = new Subject();
  private subProjectNameSubject: Subject<string> = new Subject();
  private projectNameSubject: Subject<string> = new Subject();
  public measureName$ = this.measureNameSubject.asObservable();
  public subProjctName$ = this.subProjectNameSubject.asObservable();
  public projctName$ = this.projectNameSubject.asObservable();
  public reportIndex: number;
  public measureIds = [];
  public showMeasureIcon: boolean = false;
  public currentUserName: string;
  public readonly CONFIG_PROPERTIES = [
    'Id',
    'ParentId',
    'SysTimeInsert',
    'SysTimeUpdate',
    'SysUserNameInsert',
    'SysDateUpdate',
    'SysUserNameUpdate',
    'SeqNr',
    'ObjectType',
  ];
  public res = ResourceManager.getResources('ubt-geods');
  public subProjectRequestColumns = new QueryObjectsModel();
  public subProjects: SubProject[] = [];
  public currentSubProjectIndex: number=0;
  public currentMeasureProgressIndex: number;
  public subProjectIds: string[] = [];
  private treeViewSwitchToCompany = new BehaviorSubject<boolean>(false);
  public treeViewSwitchToCompany$ = this.treeViewSwitchToCompany.asObservable();
  private treeViewSwitchToProject = new BehaviorSubject<boolean>(false);
  public treeViewSwitchToProject$ = this.treeViewSwitchToProject.asObservable();
  public loggedInUserInformations = new ReplaySubject<{ fullName: string; id: string }>();
  public loggedInUserInformations$ = this.loggedInUserInformations.asObservable();
  public isCompanySelected: boolean = false;
  public projectList: Project[] = [];
  private measureTask = new MeasureTask(null);
  private loaderSubject: Subject<boolean> = new Subject();
  public loader$: Observable<boolean> = this.loaderSubject.asObservable();
  public loadMeasureDetails: boolean = false;

  constructor() {}

  public showLoader(isLoaderVisible: boolean): void {
    this.loaderSubject.next(isLoaderVisible);
  }
  public sanitizeContent(content: string, isPastedContent?: boolean): string {
    if (content) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(content, 'text/html');

      if (isPastedContent) {
        const strongElements = doc.querySelectorAll('strong');
        strongElements.forEach((element) => {
          const parent = element.parentNode;
          while (element.firstChild) {
            parent.insertBefore(element.firstChild, element);
          }
          parent.removeChild(element);
        });
      }

      const elementsWithStyles = doc.querySelectorAll('*[style]');
      elementsWithStyles.forEach((element) => {
        let style = element.getAttribute('style') || '';

        style = style.replace(/font-size:[^;]+;?/g, '').replace(/font-family:[^;]+;?/g, '');

        if (isPastedContent) {
          style = style.replace(/font-weight:[^;]+;?/g, '').replace(/color:[^;]+;?/g, '');
        }

        const newStyle = `${style} font-size: 14px; font-family: "Helvetica Neue", "Segoe UI", helvetica, verdana, sans-serif;`;
        element.setAttribute('style', newStyle);
      });

      return doc.body.innerHTML;
    }
    return content;
  }
  public callMeasureName(measureName: string): void {
    this.measureNameSubject.next(measureName);
  }
  public loadNotOnlyMeasureDetails(check: boolean) {
    return (this.loadMeasureDetails = check);
  }

  public callSubProjectName(subProjectName: string): void {
    this.subProjectNameSubject.next(subProjectName);
  }

  public callProjectName(projectName: string): void {
    this.projectNameSubject.next(projectName);
  }

  public selectTreeItem = (selectedNode: number) => {
    this.selectItem.emit(selectedNode);
  };

  public switchTreeViewToCompany(data: boolean) {
    localStorage.setItem('switchToCompany', data.toString());
    this.treeViewSwitchToCompany.next(data);
  }

  public switchTreeViewToProject(data: boolean) {
    localStorage.setItem('switchToProject', data.toString());
    this.treeViewSwitchToProject.next(data);
  }

  public getMeasureTask(): MeasureTask {
    return this.measureTask;
  }

  public setMeasureTask(measureTask: MeasureTask): void {
    this.measureTask = measureTask;
  }
}
